import React from "react";

// 1. Définition de l'interface pour les Props
// On utilise 'string' pour la plupart, et des unions de chaînes pour les valeurs spécifiques
interface CardStatsProps {
  statSubtitle: string;
  statTitle: string;
  statArrow?: "up" | "down" | "none"; // Limite les choix possibles
  statPercent?: string;
  statPercentColor?: string;
  statDescripiron: string; // Note: attention à la faute de frappe dans le nom original ;)
  statIconName: string;
  statIconColor: string;
}

export default function CardStats({
  statSubtitle,
  statTitle,
  statArrow = "none",
  statPercent,
  statPercentColor = "text-emerald-500",
  statDescripiron,
  statIconName,
  statIconColor,
}: CardStatsProps) {
  return (
    <div className="relative flex flex-col min-w-0 break-words bg-[#1E293B] rounded-xl mb-6 xl:mb-0 shadow-lg border border-slate-700">
      <div className="flex-auto p-4">
        <div className="flex flex-wrap">
          <div className="relative w-full pr-4 max-w-full flex-grow flex-1">
            <h5 className="text-slate-400 uppercase font-bold text-[10px]">
              {statSubtitle}
            </h5>
            <span className="font-bold text-xl text-white">{statTitle}</span>
          </div>
          <div className="relative w-auto pl-4 flex-initial">
            <div
              className={`text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full ${statIconColor}`}
            >
              <i className={statIconName}></i>
            </div>
          </div>
        </div>
        <p className="text-sm text-slate-400 mt-4">
          {/* On affiche le pourcentage s'il existe, indépendamment de la flèche */}
          {statPercent && (
            <span className={`${statPercentColor} mr-2`}>
              {/* On n'affiche la flèche que si statArrow n'est pas "none" */}
              {statArrow !== "none" && (
                <i
                  className={
                    statArrow === "up" ? "fas fa-arrow-up" : "fas fa-arrow-down"
                  }
                ></i>
              )}{" "}
              {statPercent}
            </span>
          )}
          <span className="whitespace-nowrap">{statDescripiron}</span>
        </p>
      </div>
    </div>
  );
}
